import { render } from "./OtaUpdate.vue?vue&type=template&id=021ac59e&scoped=true"
import script from "./OtaUpdate.vue?vue&type=script&lang=js"
export * from "./OtaUpdate.vue?vue&type=script&lang=js"

import "./OtaUpdate.vue?vue&type=style&index=0&id=021ac59e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021ac59e"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QItemLabel,QLinearProgress});
